import { Skeleton } from "antd"
import { ColumnsType } from "antd/es/table"

/**
 * Utility function to generate skeleton columns with Skeleton components
 *
 * @param columns - The original table columns
 * @returns Columns configuration with Skeleton render functions
 */
export function getSkeletonColumns<T = Record<string, unknown>>(
  columns: ColumnsType<T>
): ColumnsType<T> {
  return columns.map((column) => ({
    ...column,
    render: () => (
      <Skeleton
        active
        title={{ width: "100%" }}
        paragraph={false}
        style={{ margin: 0 }}
      />
    ),
  }))
}

/**
 * Utility function to generate skeleton data for table loading state
 *
 * @param rowCount - Number of skeleton rows to generate
 * @returns Array of skeleton data objects
 */
export function getSkeletonData<T = Record<string, unknown>>(rowCount: number = 5): T[] {
  return Array.from({ length: rowCount }, (_, index) => ({
    id: `skeleton-${index}`,
  })) as unknown as T[]
}
